import {useEffect, useState} from 'react';
import {PAGE_SETTLED_IDLE_TIMEOUT_MS} from './utm-link-video.types';

/**
 * False until the page has finished loading and the browser has a moment to spare, so a heavy file asked for afterwards never competes
 * with the page's own first paint and scripts. Safari has no idle callback, so there it waits only for the load event.
 */
export const useIsPageSettled = (): boolean => {
  const [isPageSettled, setIsPageSettled] = useState(false);

  useEffect(() => {
    let idleHandle: number | null = null;
    let timeoutHandle: number | null = null;

    const markSettled = (): void => {
      setIsPageSettled(true);
    };

    const scheduleWhenIdle = (): void => {
      if (typeof window.requestIdleCallback === 'function') {
        idleHandle = window.requestIdleCallback(markSettled, {timeout: PAGE_SETTLED_IDLE_TIMEOUT_MS});
        return;
      }
      timeoutHandle = window.setTimeout(markSettled, 0);
    };

    if (document.readyState === 'complete') {
      scheduleWhenIdle();
    } else {
      window.addEventListener('load', scheduleWhenIdle, {once: true});
    }

    return (): void => {
      window.removeEventListener('load', scheduleWhenIdle);
      if (idleHandle !== null) {
        window.cancelIdleCallback(idleHandle);
      }
      if (timeoutHandle !== null) {
        window.clearTimeout(timeoutHandle);
      }
    };
  }, []);

  return isPageSettled;
};
